import {areaFormat, priceFormat} from "@pg-mono/string-utils";

import {friendlyQueryToDescription} from "../../constants/house_filter";
import {regionsTypesWithForSalePhrase} from "../../constants/regions_types_with_for_sale_phrase";
import {IOfferSearchPhraseParts} from "../../types/IOfferSearchPhraseParts";
import {ISearchPhraseOptions} from "../../types/ISearchPhraseOptions";
import {ISearchPhraseParams} from "../../types/ISearchPhraseParams";
import {OfferType} from "../../types/OfferType";
import castSearchPhraseParams from "./cast_search_phrase_params";
import {convertToRoomsSearchPhrase} from "./convert_to_rooms_search_phrase";

export function convertToSearchPhraseParts(data: ISearchPhraseParams, options?: ISearchPhraseOptions): IOfferSearchPhraseParts {
    const castedSearchData = castSearchPhraseParams(data);

    const hasPrice = castedSearchData.price_0 || castedSearchData.price_1;
    const hasArea = castedSearchData.area_0 || castedSearchData.area_1;

    return {
        offerType: convertToOfferTypePhrase(castedSearchData.offerType, data, options),
        sale: convertToSalePhrase(data, options),
        price: hasPrice ? `cena ${priceFormat([castedSearchData.price_0, castedSearchData.price_1])}` : null,
        instalment: castedSearchData.instalment ? `rata kredytu do ${priceFormat(castedSearchData.instalment)}` : null,
        area: hasArea ? `powierzchnia ${areaFormat([castedSearchData.area_0, castedSearchData.area_1])}` : null,
        rooms: convertToRoomsTypePhrase(castedSearchData, options)
    };
}

function convertToOfferTypePhrase(offerType: OfferType | null, data: ISearchPhraseParams, options?: ISearchPhraseOptions) {
    const isStudioApartments = data.type === OfferType.FLAT && data.rooms_1 === "1";
    const singlRoomFlatName = Boolean(options?.isTitle) ? "Kawalerka" : "kawalerki";

    //  For flats that are single room we merge "jednopokojowe" and "mieszkania" into "kawalerki" for SEO reasons
    if (isStudioApartments && !options?.disableStudioApartmentsLogic) {
        return singlRoomFlatName;
    }

    if (offerType === OfferType.FLAT && data.is_luxury) {
        return "apartamenty";
    }

    if (offerType === OfferType.FLAT) {
        return "mieszkania";
    }

    const offerTypeDescription = options && options.offerListSubFilter ? friendlyQueryToDescription[options.offerListSubFilter] : null;
    if (offerType === OfferType.HOUSE && offerTypeDescription) {
        return `domy ${offerTypeDescription}`;
    }

    if (offerType === OfferType.HOUSE) {
        return "domy";
    }

    if (offerType === OfferType.COMMERCIAL) {
        return "lokale użytkowe";
    }

    return "nieruchomości";
}

function convertToSalePhrase(data: ISearchPhraseParams, options?: ISearchPhraseOptions) {
    const isMultiRegion = !!data.regions && data.regions.length > 1;
    const isCityOrDistrict = !!data.regions && data.regions.length > 0 && regionsTypesWithForSalePhrase.includes(data.regions[0].type);
    const isSingleRegionWithoutCommercial = !isMultiRegion && isCityOrDistrict && (data.type === OfferType.FLAT || data.type === OfferType.HOUSE);

    const isStudioApartments = data.type === OfferType.FLAT && data.rooms_1 === "1";
    if (isSingleRegionWithoutCommercial && isStudioApartments && !options?.disableStudioApartmentsLogic && options?.isTitle) {
        return "sprzedaż";
    }

    if (isSingleRegionWithoutCommercial && !options?.isMetaDescription) {
        return "na sprzedaż";
    }

    return null;
}

function convertToRoomsTypePhrase(castedSearchData: ReturnType<typeof castSearchPhraseParams>, options?: ISearchPhraseOptions) {
    const {offerType, rooms_0, rooms_1} = castedSearchData;

    if (typeof rooms_0 !== "number" && typeof rooms_1 !== "number") {
        return null;
    }

    //  For flats that are single room we merge "jednopokojowe" and "mieszkania" into "kawalerki" for SEO reasons
    const isStudioApartments = offerType === OfferType.FLAT && rooms_1 === 1;
    if (isStudioApartments && !options?.disableStudioApartmentsLogic) {
        return null;
    }

    const isHouseOrFlatsButNotStudio = (offerType === OfferType.FLAT && rooms_1 !== 1) || offerType === OfferType.HOUSE;

    if (isHouseOrFlatsButNotStudio) {
        return convertToRoomsSearchPhrase(rooms_0, rooms_1, true);
    }

    return convertToRoomsSearchPhrase(castedSearchData.rooms_0, castedSearchData.rooms_1, false);
}
import {areaFormat, priceFormat} from "@pg-mono/string-utils";

import {friendlyQueryToDescription} from "../../constants/house_filter";
import {regionsTypesWithForSalePhrase} from "../../constants/regions_types_with_for_sale_phrase";
import {IOfferSearchPhraseParts} from "../../types/IOfferSearchPhraseParts";
import {ISearchPhraseOptions} from "../../types/ISearchPhraseOptions";
import {ISearchPhraseParams} from "../../types/ISearchPhraseParams";
import {OfferType} from "../../types/OfferType";
import castSearchPhraseParams from "./cast_search_phrase_params";
import {convertToRoomsSearchPhrase} from "./convert_to_rooms_search_phrase";

export function convertToSearchPhraseParts(data: ISearchPhraseParams, options?: ISearchPhraseOptions): IOfferSearchPhraseParts {
    const castedSearchData = castSearchPhraseParams(data);

    const hasPrice = castedSearchData.price_0 || castedSearchData.price_1;
    const hasArea = castedSearchData.area_0 || castedSearchData.area_1;

    return {
        offerType: convertToOfferTypePhrase(castedSearchData.offerType, data, options),
        sale: convertToSalePhrase(data, options),
        price: hasPrice ? `cena ${priceFormat([castedSearchData.price_0, castedSearchData.price_1])}` : null,
        instalment: castedSearchData.instalment ? `rata kredytu do ${priceFormat(castedSearchData.instalment)}` : null,
        area: hasArea ? `powierzchnia ${areaFormat([castedSearchData.area_0, castedSearchData.area_1])}` : null,
        rooms: convertToRoomsTypePhrase(castedSearchData, options)
    };
}

function convertToOfferTypePhrase(offerType: OfferType | null, data: ISearchPhraseParams, options?: ISearchPhraseOptions) {
    const isStudioApartments = data.type === OfferType.FLAT && data.rooms_1 === "1";
    const singlRoomFlatName = Boolean(options?.isTitle) ? "Kawalerka" : "kawalerki";

    //  For flats that are single room we merge "jednopokojowe" and "mieszkania" into "kawalerki" for SEO reasons
    if (isStudioApartments && !options?.disableStudioApartmentsLogic) {
        return singlRoomFlatName;
    }

    if (offerType === OfferType.FLAT && data.is_luxury) {
        return "apartamenty";
    }

    if (offerType === OfferType.FLAT) {
        return "mieszkania";
    }

    const offerTypeDescription = options && options.offerListSubFilter ? friendlyQueryToDescription[options.offerListSubFilter] : null;
    if (offerType === OfferType.HOUSE && offerTypeDescription) {
        return `domy ${offerTypeDescription}`;
    }

    if (offerType === OfferType.HOUSE) {
        return "domy";
    }

    if (offerType === OfferType.COMMERCIAL) {
        return "lokale użytkowe";
    }

    return "nieruchomości";
}

function convertToSalePhrase(data: ISearchPhraseParams, options?: ISearchPhraseOptions) {
    const isMultiRegion = !!data.regions && data.regions.length > 1;
    const isCityOrDistrict = !!data.regions && data.regions.length > 0 && regionsTypesWithForSalePhrase.includes(data.regions[0].type);
    const isSingleRegionWithoutCommercial = !isMultiRegion && isCityOrDistrict && (data.type === OfferType.FLAT || data.type === OfferType.HOUSE);

    const isStudioApartments = data.type === OfferType.FLAT && data.rooms_1 === "1";
    if (isSingleRegionWithoutCommercial && isStudioApartments && !options?.disableStudioApartmentsLogic && options?.isTitle) {
        return "sprzedaż";
    }

    if (isSingleRegionWithoutCommercial && !options?.isMetaDescription) {
        return "na sprzedaż";
    }

    return null;
}

function convertToRoomsTypePhrase(castedSearchData: ReturnType<typeof castSearchPhraseParams>, options?: ISearchPhraseOptions) {
    const {offerType, rooms_0, rooms_1} = castedSearchData;

    if (typeof rooms_0 !== "number" && typeof rooms_1 !== "number") {
        return null;
    }

    //  For flats that are single room we merge "jednopokojowe" and "mieszkania" into "kawalerki" for SEO reasons
    const isStudioApartments = offerType === OfferType.FLAT && rooms_1 === 1;
    if (isStudioApartments && !options?.disableStudioApartmentsLogic) {
        return null;
    }

    const isHouseOrFlatsButNotStudio = (offerType === OfferType.FLAT && rooms_1 !== 1) || offerType === OfferType.HOUSE;

    if (isHouseOrFlatsButNotStudio) {
        return convertToRoomsSearchPhrase(rooms_0, rooms_1, true);
    }

    return convertToRoomsSearchPhrase(castedSearchData.rooms_0, castedSearchData.rooms_1, false);
}
